<template>
  <div class="page">
    <el-pagination
      background
      hide-on-single-page
      @current-change="changePage"
      layout="total, prev, pager, next, jumper"
      :page-size="size"
      :current-page="page"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>

  export default {
    name: 'page',
    props: {
      page: { //当前页码
        type: Number,
        default: 1
      },
      size: {//每页条数
        type: Number,
        default: 10
      },
      total: {//总的条数
        type: Number,
      },
    },
    data() {
      return {}
    },
    computed: {},
    methods: {
      changePage(page) {
        this.$emit("onPage", page)
      }
    },
  }
</script>

<style lang="less" scoped>
  .page {
    margin: 20px auto;
    text-align: center;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #654719;
  }

</style>
